import React from 'react';
import { Modal } from './index';

// Click-to-zoom for a thumbnail image (TTT-84) — e.g. a payment QR too small to scan as shown.
// Renders the thumbnail exactly as passed in `thumbStyle` so existing layouts (centring,
// borders) are unaffected. The thumbnail sits in a button, so a keyboard can open the enlarged
// view and focus has somewhere to return when it closes (DS-2). The enlarged view is the shared
// dialog, named by the image's alt text.
export function ImageLightbox({ src, alt, thumbStyle }) {
  const [open, setOpen] = React.useState(false);

  if (!src) return null;

  const close = () => setOpen(false);

  return (
    <>
      {/* A full-width block that aligns like its parent, so the image inside sits where it did
          before it had a button around it. */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{ display: 'block', width: '100%', padding: 0, margin: 0, border: 'none', background: 'none', textAlign: 'inherit', font: 'inherit', cursor: 'zoom-in' }}>
        <img src={src} alt={alt} style={{ cursor: 'zoom-in', ...thumbStyle }} />
      </button>
      {open && (
        <Modal onClose={close} label={alt} maxWidth={720}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '56px 24px 24px' }}>
            {/* Fills the card's width (about 300 px on a 390 px phone) however small the upload is,
                so a QR is big enough to scan; `contain` keeps tall screenshots whole. */}
            <img src={src} alt={alt} style={{ width: '100%', maxHeight: '75vh', objectFit: 'contain', borderRadius: 12 }} />
          </div>
        </Modal>
      )}
    </>
  );
}
